// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2M9DV","itemTitle":"ClientEmergencyInfo_itemTitle__3CZOX","itemText":"ClientEmergencyInfo_itemText__3OrEV"};